import { SUCCESS_FETCH_RECHARGE_BIRONEX, CLEAR_RECHARGE_BIRONEX_BLOCK, } from '../actions/bironex';
import { saveChequeBlock, clearChequeBlock, } from '../shared/chequeBlockStorage';
var getGamblerId = function (store) {
    var user = store.getState().auth.user;
    return user && user.gamblerId;
};
export default (function (store) { return function (next) { return function (action) {
    var result = next(action);
    var gamblerId = getGamblerId(store);
    if (!gamblerId) {
        return result;
    }
    if (action.type === SUCCESS_FETCH_RECHARGE_BIRONEX) {
        var data = action.data || {};
        if (data.timeout > 0) {
            saveChequeBlock(gamblerId, data.timeout);
        }
        else if (!data.error && !data.validationError && data.amount != null) {
            clearChequeBlock(gamblerId);
        }
    }
    if (action.type === CLEAR_RECHARGE_BIRONEX_BLOCK) {
        clearChequeBlock(gamblerId);
    }
    return result;
}; }; });



// WEBPACK FOOTER //
// ./src/middleware/chequeBlockMiddleware.js